import { setAuthToken, instance, fetchRequest } from "./fetchData";
import client from "../utils/client";

export function fetchProductData({ url }) {
  const authToken = client.getToken();
  setAuthToken(authToken);

  return fetchRequest(instance.post(`/product`, { url }));
}
